var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-aboutus"},[_c('h1',[_vm._v("JHI協同組合について")]),_c('UiLine'),_c('div',{staticClass:"aboutus"},[_c('img',{attrs:{"src":`${_vm.rootUrl}/img/JHI-h_002.jpg`,"alt":"JHI協同組合について"}}),_c('p',[_vm._v(" 業務内容としては「外国人技能実習生の共同受入事業」と「共同購買事業」に力を入れて活動を行っており、拠点は産業がとても多い愛知県に事務所があります。 組合員様や技能実習生が全員が笑顔で幸せになれるような活動を行っております。 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }